import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";
import spinner from '../assets/img/spinner.svg';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["Software Engineer", "Web Developer", "App Developer"];
  const period = 2000;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };
  const [myData, setMyData] = useState([]);
  async function fetchData() {
    try {
      setLoading(true);
      const projectRef = collection(db, "profile");
      const q = query(projectRef);
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setMyData(projects);
      setLoading(false);
      //console.log(projects);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                  style={{
                    ...(window.innerWidth <= 768 && {
                      textAlign: "center",
                    }),
                  }}
                >
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1
                    style={{
                      ...(window.innerWidth <= 768 && {
                        fontSize: "50px",
                      }),
                    }}
                  >
                    {`Hi! I'm Kushan Andarawewa`}
                    <br></br>
                    <span
                      className="txt-rotate"
                      dataPeriod="1000"
                      data-rotate='[ "Software Engineer", "Web Developer", "App Developer" ]'
                    >
                      <span
                        className="wrap"
                        style={{ fontSize: "30px", color: "orange" }}
                      >
                        {text}
                      </span>
                    </span>
                  </h1>
                  <p>
                    My portfolio showcases projects and achievements from my
                    journey as a Software Engineering undergraduate at
                    Sabaragamuwa University. Explore my passion for innovative
                    solutions, software development skills, and commitment to
                    learning through practical applications and academic
                    excellence
                  </p>
                  {/* <button onClick={() => console.log("connect")}>
                    Let’s Connect <ArrowRightCircle size={25} />
                  </button> */}
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                  style={{
                    marginLeft: "150px",
                    ...(window.innerWidth <= 1200 && {
                      marginLeft: "0px",
                    }),
                    ...(window.innerWidth <= 768 && {
                      marginLeft: "0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }),
                  }}
                >
                  {loading ? (
                    <img
                      src={spinner}
                      alt="Loading..."
                      style={{
                        width: "100px", // Adjust width as needed
                        height: "100px", // Adjust height as needed
                      }}
                    />
                  ) : (
                    <img
                      src={myData[0]?.data.profileImage}
                      alt="My Image"
                      style={{
                        borderRadius: "50%",
                        width: "300px",
                        height: "300px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  {/* <img
                      src={myData[0]?.data.profileImage}
                      alt="My Image"
                      style={{
                        borderRadius: "50%",
                        width: "300px",
                        height: "300px",
                        objectFit: "cover",
                      }}
                    /> */}
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
